import { FC } from 'react'

import Rapid7Logo from '@/assets/logos/rapid7.svg?react'
import ServiceIntegrationCard from '@/components/service-integration-card'
import { Logging } from '@/out/logging'
import { LoggingProps } from '@/pages/settings/logging'
import Rapid7Details from '@/pages/settings/logging/rapid7/details'
import Rapid7Form from '@/pages/settings/logging/rapid7/form'

type Props = LoggingProps<'rapid7'> & {
  configuration: Logging['rapid7']
}

const Rapid7: FC<Props> = ({ configuration, onSetup, setupTimer, onTest, testTimer, onRemove, removeTimer }) => {
  return (
    <ServiceIntegrationCard
      title="Rapid7"
      description="Receive logs in Rapid7 Insight Platform"
      icon={<Rapid7Logo className="w-8 h-8" />}
      iconColor="text-[#FF6B35] dark:text-white"
      isConnected={!!configuration}
      setupContent={
        <Rapid7Form
          setupTimer={setupTimer}
          testTimer={testTimer}
          onSetup={config => onSetup('rapid7', config)}
          onTest={config => onTest('rapid7', config)}
        />
      }
      manageContent={
        configuration && (
          <Rapid7Details configuration={configuration} timer={removeTimer} onRemove={() => onRemove('rapid7')} />
        )
      }
    />
  )
}

export default Rapid7
